module.exports = {"activation.modal.content.text":"Veuillez patienter pendant que nous vous connectons et activer votre abonnement.","activation.modal.content.status":"Activation"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr/components/ModalContent/Activation.json
// module id = 798
// module chunks = 0